import { render, staticRenderFns } from "./mobilePlay.vue?vue&type=template&id=022bca0c&scoped=true&"
import script from "./mobilePlay.vue?vue&type=script&lang=js&"
export * from "./mobilePlay.vue?vue&type=script&lang=js&"
import style0 from "./mobilePlay.vue?vue&type=style&index=0&id=022bca0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022bca0c",
  null
  
)

export default component.exports